var map = {
	"./about-screen/oil-paint-all.webp": 7913,
	"./animation/animation.css": 403,
	"./animation/animationSpawn.css": 6628,
	"./background/background-footer.webp": 5321,
	"./background/background-mobile-burger.webp": 3031,
	"./brands/Best Lawyers-dark.svg": 6384,
	"./brands/Best Lawyers-light.svg": 4324,
	"./brands/Chambers and Partners-dark.svg": 1273,
	"./brands/Chambers and Partners-light.svg": 2591,
	"./brands/Financial Times-dark.svg": 7620,
	"./brands/Financial Times-light.svg": 9134,
	"./brands/Forbes Club-dark.svg": 9777,
	"./brands/Forbes Club-light.svg": 8773,
	"./brands/LEGAL 500-dark.svg": 332,
	"./brands/LEGAL 500-light.svg": 8281,
	"./brands/Коммерсантъ-dark.svg": 1205,
	"./brands/Коммерсантъ-light.svg": 1443,
	"./brands/ПРАВО 300-dark.svg": 6664,
	"./brands/ПРАВО 300-light.svg": 5520,
	"./icons/arrow-dark.svg": 1490,
	"./icons/arrow-light.svg": 47,
	"./icons/blot-dark-hover.svg": 7348,
	"./icons/blot-dark.svg": 3028,
	"./icons/blot-light-hover.svg": 1746,
	"./icons/blot-light.svg": 267,
	"./icons/check-mark-circle-dark.svg": 2715,
	"./icons/check-mark-circle-light.svg": 4892,
	"./icons/cross-2-dark.svg": 1140,
	"./icons/cross-2-light.svg": 4222,
	"./icons/cross-dark.svg": 4919,
	"./icons/cross-light.svg": 1423,
	"./icons/download-dark.svg": 2696,
	"./icons/download-light.svg": 1676,
	"./icons/eye.svg": 5564,
	"./icons/glass-dark.svg": 8942,
	"./icons/glass-light.svg": 1794,
	"./icons/link.svg": 7966,
	"./icons/menu-burger-dark.svg": 3617,
	"./icons/menu-burger-light.svg": 5963,
	"./icons/pointer-menu-dark.svg": 9014,
	"./icons/pointer-menu-light.svg": 7183,
	"./icons/save-dark.svg": 4252,
	"./icons/save-light.svg": 7715,
	"./icons/setting-icon-dark.svg": 1562,
	"./icons/setting-icon-light.svg": 9298,
	"./icons/single-arrow-bottom-dark.svg": 1137,
	"./icons/single-arrow-bottom-light.svg": 7636,
	"./icons/single-arrow-bottom-two-light.svg": 8723,
	"./icons/single-arrow-left-dark.svg": 3197,
	"./icons/single-arrow-left-light.svg": 9165,
	"./icons/single-arrow-right-dark.svg": 4483,
	"./icons/single-arrow-right-light.svg": 4421,
	"./icons/single-arrow-top-dark.svg": 8998,
	"./icons/single-arrow-top-light.svg": 3102,
	"./icons/single-arrow-top-two-light.svg": 6527,
	"./icons/small-blot-dark.svg": 7500,
	"./icons/small-blot-light.svg": 7997,
	"./icons/toggle-dark-hover.svg": 723,
	"./icons/toggle-dark.svg": 5049,
	"./icons/toggle-light-hover.svg": 4590,
	"./icons/toggle-light.svg": 7965,
	"./icons/user-dark.svg": 5347,
	"./icons/user-light.svg": 5968,
	"./icons/user-support-dark.svg": 4370,
	"./icons/user-support-light.svg": 7017,
	"./logo/logo-dark.svg": 9655,
	"./logo/logo-light.svg": 2080,
	"./logo/logo-mobile-dark.svg": 2850,
	"./logo/logo-mobile-light.svg": 41,
	"./logo/logo-without-dark.svg": 4915,
	"./logo/logo-without-light.svg": 2611,
	"./logo/look-dark.svg": 8496,
	"./logo/look-light.svg": 6661,
	"./logo/main-logo.svg": 7087,
	"./lottie/BigLogo": 9549,
	"./lottie/BigLogo.json": 9549,
	"./lottie/BigLogoFooterDark": 4783,
	"./lottie/BigLogoFooterDark.json": 4783,
	"./lottie/BigLogoFooterLight": 7201,
	"./lottie/BigLogoFooterLight.json": 7201,
	"./lottie/BrashDarkTheme": 4481,
	"./lottie/BrashDarkTheme.json": 4481,
	"./lottie/BrashLightTheme": 6040,
	"./lottie/BrashLightTheme.json": 6040,
	"./lottie/BrashTeamDarkTheme": 5775,
	"./lottie/BrashTeamDarkTheme.json": 5775,
	"./lottie/BrashTeamDarkThemeMobile": 8520,
	"./lottie/BrashTeamDarkThemeMobile.json": 8520,
	"./lottie/BrashTeamLightTheme": 1624,
	"./lottie/BrashTeamLightTheme.json": 1624,
	"./lottie/BrashTeamLightThemeMobile": 656,
	"./lottie/BrashTeamLightThemeMobile.json": 656,
	"./lottie/LogoContactsDarkTheme": 4182,
	"./lottie/LogoContactsDarkTheme.json": 4182,
	"./lottie/LogoContactsLightTheme": 5043,
	"./lottie/LogoContactsLightTheme.json": 5043,
	"./lottie/LogoMain": 3368,
	"./lottie/LogoMain.json": 3368,
	"./lottie/MainBrash": 9075,
	"./lottie/MainBrash.json": 9075,
	"./lottie/Pattern": 6511,
	"./lottie/Pattern.json": 6511,
	"./lottie/PatternDarkTheme": 7026,
	"./lottie/PatternDarkTheme.json": 7026,
	"./lottie/PatternDarkThemeMobile": 1764,
	"./lottie/PatternDarkThemeMobile.json": 1764,
	"./lottie/PatternLightTheme": 6860,
	"./lottie/PatternLightTheme.json": 6860,
	"./lottie/PatternLightThemeMobile": 9930,
	"./lottie/PatternLightThemeMobile.json": 9930,
	"./lottie/PreloaderDarkTheme": 6865,
	"./lottie/PreloaderDarkTheme.json": 6865,
	"./lottie/PreloaderLightTheme": 2386,
	"./lottie/PreloaderLightTheme.json": 2386,
	"./lottie/ValuesDarkTheme_1": 9738,
	"./lottie/ValuesDarkTheme_1.json": 9738,
	"./lottie/ValuesDarkTheme_2": 9361,
	"./lottie/ValuesDarkTheme_2.json": 9361,
	"./lottie/ValuesDarkTheme_3": 970,
	"./lottie/ValuesDarkTheme_3.json": 970,
	"./lottie/ValuesDarkTheme_4": 2234,
	"./lottie/ValuesDarkTheme_4.json": 2234,
	"./lottie/signature-dark": 1178,
	"./lottie/signature-dark.json": 1178,
	"./lottie/signature-light": 1416,
	"./lottie/signature-light.json": 1416,
	"./styles/main.css": 3405,
	"./team-screen/team/avatar-default.webp": 8282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;